"use strict";
define(
    'stores/ideas-lab',[
        "jquery",
        "stores/store",
        "actions/ideas-lab",
        "constants/actiontypes",
        "xregexp"
    ],
    function ($, StoreBase, Action, Constants, XRegExp)
    {
        Store.prototype = new StoreBase();
        Store.constructor = Store;

        function Store (params)
        {
            // Call parent constructor
            StoreBase.call(this, params);

            // Setup the instance
            this.items = {};

            this.registerDispatchListener(function (action) {
                var self = this;
                switch(action.actionType) {
                    case Constants.FETCHED_IDEASLAB:
                        this.fetched = true;
                        this.event.emit("change");
                        break;
                }
            }.bind(this));

            this.fetched = false;

            this.action = new Action();
        }

        Store.prototype.getAll = function(filterOptions, sortPreference)
        {
            if(!this.fetched)
                return false;
            
            var filtered = [];
            if(typeof filterOptions == "undefined") {
                filtered = _.map(this.items, function (item) { return item; });
            }
            else {
                filtered = _.filter(this.items, function (item) {
                    if(typeof filterOptions.parent != "undefined" && filterOptions.parent != item.parent_guid) {
                        return false;
                    } else if(typeof filterOptions.type != "undefined" && filterOptions.type != item.type) {
                        return false;
                    }
                    return true;
                });
            }
            
            filtered = this.sortItems(filtered, sortPreference);

            if(filtered.length == 0 && !this.fetched) {
                return false;
            }
            return filtered;
        };

        Store.prototype.hasItem = function(id)
        {
            return (id.toLowerCase() in this.items);
        };

        Store.prototype.getItem = function(id)
        {
            return this.items[id.toLowerCase()];
        };

        Store.prototype.clearSectionCache = function(sectionId){
            delete this.sectionCache[sectionId];
        };

        Store.prototype.filterByOwner = function (ownerId)
        {
            var filtered = [];
            _.each(this.items, function (item, index, list)
            {
                if(item.owner_guid == ownerId)
                    filtered.push(item);
            }, this);

            return filtered;
        }

        Store.prototype.filterByOwners = function (ownerIds)
        {
            var self = this;
            var filtered = [];
            _.each(ownerIds, function(ownerId) {
                _.each(self.items, function (item, index, list)
                {
                    if(item.owner_guid == ownerId)
                        filtered.push(item);
                }, this);
            });

            return filtered;
        }

        Store.prototype.filterByKeyword = function(keyword, sortPreference) {
            // Trim all spaces from beginning and ending
            keyword = keyword.trim();

            // Make a regular expression to allow all characters, numerics, and spaces
            var allowCharacterSets = XRegExp("[^\\pL\\s\\d]+", "g");

            // Replace all special characters as nothing and space as OR("|")
            keyword = XRegExp.replace(keyword, allowCharacterSets, "");
            keyword = keyword.trim().replace(/\s+/g, "|");

            // Make a regular expression to search with keyword
            var regExp = new RegExp(keyword, "i");

            var filtered = [];
            _.each(this.items, function(item) {
                if(regExp.test(item.title))
                    filtered.push(item);
            });

            filtered = this.sortItems(filtered, sortPreference);
            return filtered;
        }

        /**
         * Sort items
         *
         * @param {array} An array of items
         * @param {string} Preference for a sorting order
         * @return {array} A sorted array
         * @see It should be extended to be sortable customized orders
         **/
        Store.prototype.sortItems = function(items, sortPreference)
        {
            switch(sortPreference) {
                case 'created_desc':
                    items.sort(function(a, b) {
                        var a_createdAt = new Date(a.created_at).getTime();
                        var b_createdAt = new Date(b.created_at).getTime();

                        if(a_createdAt > b_createdAt)
                            return -1;
                        else if(a_createdAt < b_createdAt)
                            return 1;
                        return 0;
                    });
                    break;
                case 'created_asc':
                    items.sort(function(a, b) {
                        var a_createdAt = new Date(a.created_at).getTime();
                        var b_createdAt = new Date(b.created_at).getTime();

                        if(a_createdAt < b_createdAt)
                            return -1;
                        else if(a_createdAt > b_createdAt)
                            return 1;
                        return 0;
                    })
                    break;
                case 'updated_desc':
                    items.sort(function(a, b) {
                        var a_updatedAt = new Date(a.updated_at).getTime();
                        var b_updatedAt = new Date(b.updated_at).getTime();

                        if(a_updatedAt > b_updatedAt)
                            return -1;
                        else if(a_updatedAt < b_updatedAt)
                            return 1;
                        return 0;
                    });
                    break;
                case 'updated_asc':
                    items.sort(function(a, b) {
                        var a_updatedAt = new Date(a.updated_at).getTime();
                        var b_updatedAt = new Date(b.updated_at).getTime();

                        if(a_updatedAt < b_updatedAt)
                            return -1;
                        else if(a_updatedAt > b_updatedAt)
                            return 1;
                        return 0;
                    });
                    break;
                default:
                    items.sort(function(a, b) {
                        if(a.type != b.type)
                            return (a.type == "folder") ? -1 : 1;

                        var a_createdAt = new Date(a.created_at).getTime();
                        var b_createdAt = new Date(b.created_at).getTime();
                        if(a_createdAt > b_createdAt)
                            return -1;
                        else if(a_createdAt < b_createdAt)
                            return 1;
                        return 0;
                    });
                    break;
            }

            return items;
        }

        // Store.prototype.getBreadCrumbs = function(guid) {
        //     var paths = [];

        //     while(guid)  {
        //         if(!this.items[guid]){
        //             break;
        //         }
        //         var crumb = {
        //             title: this.items[guid].title,
        //             guid: guid
        //         };
        //         paths.unshift(crumb);

        //         guid = this.items[guid].parent_guid;
        //     }

        //     return paths;
        // }

        return Store;
    });

